import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { ref, watch, nextTick, computed } from 'vue'
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface ITabsIconItem {
  key: string;
  title: string;
  icon: any;
}

interface IProps {
  tabs: ITabsIconItem[];
  activeTab: string;
  isShowName?: boolean;
  isShowBorderTop?: boolean;
  modifyClass?: string;
  isMin?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TabsIcon',
  props: {
    tabs: {},
    activeTab: { default: "" },
    isShowName: { type: Boolean, default: false },
    isShowBorderTop: { type: Boolean, default: false },
    modifyClass: { default: "" },
    isMin: { type: Boolean, default: false }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const activeElement = ref<HTMLElement | null>(null)
const emits = __emit

const changeTag = (tag: string) => {
  emits("change", tag);
};

watch(() => props.activeTab, async () => {
  await nextTick()
  const el = document.querySelector('.as-match-detail .as-tabs-icon__item.as-active')
  if (!el) return

  activeElement.value = el as HTMLElement
  el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-tabs-icon", {
      [`as-tabs-icon-${siteName.value}`]: siteName.value,
      'as-tabs-icon__border-top': _ctx.isShowBorderTop,
      'as-tabs-icon__min': _ctx.isMin,
      [_ctx.modifyClass]: _ctx.modifyClass,
    }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: _normalizeClass(["as-tabs-icon__item", {
        'as-active': _ctx.activeTab === tab.key,
      }]),
        onClick: ($event: any) => (changeTag(tab.key))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon))),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.isShowName ? 'as-show-name' : 'as-hide-name')
        }, _toDisplayString(tab.title), 3)
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}
}

})